import { ColumnState } from 'ag-grid-community'

// ガントチャート専用モック画面（ProjectPlanGantt.tsx, functionUuid=
// mock-project-plan-gantt-function-uuid）向けの列設定。
// この画面は通常のProjectPlanNewをそのまま使い、ganttOnlyModeのような専用
// propや専用ヘッダーは持たない。通常画面はUIStateに保存された列設定が
// 無ければ全列表示のデフォルトのままになるが、ガント専用画面は「表示名・
// ステータス・予定開始日・予定終了日・ガントチャート」の5列だけを表示
// したいため、それ以外の全列を明示的に hide: true にしたColumnStateを
// UIStateの保存値として返す（画面側には列を絞り込む実装を追加しない）。
//
// 注意: HIDDEN_COL_IDS はdefaultColumns.tsの列定義と手動同期が必要（列が
// 追加された場合はここにも追記すること）。また、列設定はUIStateの一度
// きりの適用（applyColumnState）で実現しているため、通常ヘッダーの列設定
// ポップアップから「初期化」操作（gridApi.resetColumnState）を行うと
// 全列が復活する（この画面固有の制約ではなく、列設定ポップアップを持つ
// 画面全般に言えることだが、デモの見た目を壊しうる操作なので明記する）。
export const GANTT_ONLY_MOCK_FUNCTION_UUID =
  'mock-project-plan-gantt-function-uuid'

const VISIBLE_COL_IDS = [
  'body.wbsItem.status',
  'body.wbsItem.scheduledDate.startDate',
  'body.wbsItem.scheduledDate.endDate',
  'ganttChart',
]

const HIDDEN_COL_IDS = [
  'uuid',
  'rowNumber',
  'action',
  'body.wbsItem.type',
  'body.wbsItem.ticketType',
  'body.wbsItem.substatus',
  'body.deliverableAttachmentSummary',
  'body.wbsItem.priority',
  'body.wbsItem.difficulty',
  'body.wbsItem.description',
  'body.wbsItem.team',
  'body.wbsItem.sprint',
  'body.wbsItem.sprints',
  'body.wbsItem.tags',
  'body.wbsItem.watchers',
  'body.wbsItem.estimatedHour',
  'body.wbsItem.estimatedHour.deliverable',
  'body.wbsItem.accountable',
  'body.wbsItem.responsible',
  'body.wbsItem.assignee',
  'startDelayDays',
  'endDelayDays',
  'body.wbsItem.estimatedAmount.deliverable',
  'body.wbsItem.estimatedAmount.task',
  'body.wbsItem.actualAmount',
  'completionAmountRate',
  'body.wbsItem.progressRate',
  'progress.scheduledProgressRate',
  'progress.progressRate',
  'progress.total',
  'progress.scheduledToBe',
  'progress.completed',
  'progress.preceding',
  'progress.delayed',
  'progress.remaining',
  'evm.costVariance',
  'evm.costPerformanceIndex',
  'evm.scheduleVariance',
  'evm.schedulePerformanceIndex',
  'evm.estimateToComplete',
  'evm.estimateAtCompletion',
  'evm.varianceAtCompletion',
  'body.wbsItem.revision',
  'body.wbsItem.createdBy',
  'body.wbsItem.createdAt',
  'body.wbsItem.updatedBy',
  'body.wbsItem.updatedAt',
]

export const ganttOnlyModeColumnState: ColumnState[] = [
  ...VISIBLE_COL_IDS.map(colId => ({ colId, hide: false })),
  ...HIDDEN_COL_IDS.map(colId => ({ colId, hide: true })),
]
